const patterns = {
  'Running bond': {
    w: 80,
    h: 40,
    rects: [[0, 0], [40, 0], [-20, 20], [20, 20], [60, 20]],
    size: [36, 16]
  },
  'Basket weave': {
    w: 80,
    h: 80,
    rects: [[2, 2, 36, 16], [2, 22, 36, 16], [42, 2, 16, 36], [62, 2, 16, 36], [2, 42, 16, 36], [22, 42, 16, 36], [42, 42, 36, 16], [42, 62, 36, 16]]
  },
  Diagonal: {
    w: 80,
    h: 40,
    rects: [[0, 0], [40, 0], [-20, 20], [20, 20], [60, 20]],
    size: [36, 16],
    rotate: 45
  }
};

export const patternNames = Object.keys(patterns);

function PatternPreview({ material, pattern }) {
  const p = patterns[pattern];
  const id = `pat-${pattern.replace(/\s/g, '')}-${material.name.replace(/\s/g, '')}`;
  return (
    <svg
      className="h-full w-full"
      role="img"
      aria-label={`${material.name} pavers in a ${pattern} pattern (illustrative)`}
    >
      <defs>
        <pattern
          id={id}
          width={p.w}
          height={p.h}
          patternUnits="userSpaceOnUse"
          patternTransform={p.rotate ? `rotate(${p.rotate}) scale(1.1)` : 'scale(1.1)'}
        >
          <rect width={p.w} height={p.h} fill={material.grout} />
          {p.rects.map((r, i) => (
            <rect
              key={i}
              x={r[0] + 2}
              y={r[1] + 2}
              width={r[2] || p.size[0]}
              height={r[3] || p.size[1]}
              fill={material.color}
              opacity={i % 3 === 0 ? 0.88 : 1}
              rx="1"
            />
          ))}
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${id})`} />
    </svg>
  );
}

export default PatternPreview;
